import React from "react";
import { Grid, Chip, Divider } from "@material-ui/core";
export const ActivitySegmentHeader = ({ label }) => (React.createElement(Grid, { item: true, sm: 12 },
    React.createElement("div", { style: {
            position: "relative",
            // top: "-5px",
            textAlign: "center",
            fontSize: "1.1em",
            fontWeight: "bold",
        } },
        React.createElement(Chip, { label: label }),
        React.createElement(Divider, { style: {
                position: "relative",
                top: "-16px",
                zIndex: -999,
            } }))));
